import {BrandingData, domains} from "@/domains";

let brandingCache : BrandingData|null = null;

const Branding = function() : BrandingData {
  if (brandingCache) {
    return brandingCache;
  }

  let domain = window.location.hostname;

  let branding = domains[domain];
  if (!branding) {
    return domains["default"];
  }

  brandingCache = branding
  return branding;
}
export default Branding